<template>
  <div>
    <div v-if="collecteLoad && objectif">
      <v-btn text exact :to="{ name: 'Collecte', params: { identifiantCollecte }, query: { ...$route.query } }" class="mb-3"
        ><v-icon class="mr-2">mdi-arrow-left</v-icon>{{ $t("collecte.retourAuxObjectifs") }}</v-btn
      >
      <h1 class="display-2 mt-8 mb-3">{{ collecte.titre }}</h1>
      <v-divider class="mt-2 mb-4"></v-divider>
      <objectif-card :objectif="objectif" hideDonationButton></objectif-card>
      <FormulaireDonP2P />
    </div>

    <div v-else>
      <v-skeleton-loader type="heading" class="mb-6"></v-skeleton-loader>
      <v-skeleton-loader type="text@4" class="mb-12"></v-skeleton-loader>
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import ObjectifCard from "./ObjectifCard"
import FormulaireDonP2P from "./FormulaireDonP2P"
import ChargementCollecte from "@/mixins/ChargementCollecte"
export default {
  name: "Objectif",
  mixins: [ChargementCollecte],
  components: { ObjectifCard, FormulaireDonP2P },
  computed: {
    ...mapGetters(["objectifByCollecteIdAnId"]),
    objectif() {
      return this.objectifByCollecteIdAnId(this.identifiantCollecte, this.$route.params.identifiantObjectif)
    }
  },
  mounted() {
    if (!this.objectif || this.$route.query.forceRefresh) {
      this.chargerCollecteEnCours()
    }
  }
}
</script>

<style scoped>
</style>